import React from 'react';
import {
  Alert,
  AlertTitle,
  Breakpoint,
  Container,
  LinearProgress,
  Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { BaseModal, BaseModalProps } from './BaseModal';

const useStyles = makeStyles(theme => {
  return {
    linearProgress: {
      height: 7,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0
    },
    linearProgressHidden: {
      display: 'none'
    },
    title: {
      color: (theme.palette.text as any).TextLight100,
      ...(theme.typography as any).CardTitle,
      padding: '16px'
    },
    errorAlert: {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      marginBottom: '16px',
      borderRightColor: 'transparent',
      borderTopColor: 'transparent',
      borderLeftColor: 'transparent'
    }
  };
});

type RetailModalProps = {
  loading?: boolean;
  errorDescription?: React.ReactChild;
  description?: string;
  maxWidth?: Breakpoint;
} & BaseModalProps;

// todo: rename to some thing more abstract, will be used for more than just retail
export class RetailModal extends BaseModal<RetailModalProps> {
  onClose() {
    if (!this?.props?.loading) {
      this?.props?.onClose();
    }
  }
  CloseIcon: React.FC<{}> = () => null;
  Actions: React.FC = () => null;
  Icon: React.FC = () => null;
  Header: React.FC<{}> = () => {
    const { loading, errorDescription, title, description } = this.props;
    const classes = useStyles();

    return (
      <>
        <Container style={{ padding: 0, margin: 0, marginBottom: '10px' }}>
          <LinearProgress
            style={{
              display: loading ? 'block' : 'none',
              height: 7
            }}
            className={
              loading ? classes.linearProgress : classes.linearProgressHidden
            }
          />
          {errorDescription ? (
            <Alert severity="error" className={classes.errorAlert}>
              <AlertTitle>{title}</AlertTitle>
              {errorDescription}
            </Alert>
          ) : null}
          {!errorDescription ? (
            <>
              <Typography variant="body1" className={classes.title}>
                {title}
                <br />
                <Typography variant="body4">{description}</Typography>
              </Typography>
            </>
          ) : null}
        </Container>
      </>
    );
  };

  Content: React.FC = ({ children }) => <>{children}</>;
}
